<template>
    <div class="bg-grey full-height">
    
        <CRow class="m-0 justify-content-center align-items-center">
            <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Change Password</span>
                </h5>
    
            </CCol>
    
            <CCol sm="8" class="text-center mt-3" style="width: 90%; background-size: cover; margin: auto;">
                <h5 class="custom-18px poppin-font mt-2 text-left">Forgot Password</h5>
                <div class="ustom-sub-title-app text-left mb-5 poppin-font">
                    Select verification method and we will send verification code
                </div>
                    <CRow @click="GoToVerify()">
                        <div style="width:20%;"><img style="width:30px" src="../assets/img/emailRound.png" /></div>
                        <div style="width:60%;">
                            <CRow>
                                <h5 class="custom-14px poppin-font mt-2 text-left">Email</h5>
                                <br />
                                <br />
                                <div style="width:100%;">
                                    <h5 class="custom-12px poppin-font text-left">********@mail.com</h5>
                                </div>
                            </CRow>
                        </div>
                        <div style="width:20%;"><img style="width:20px" src="../assets/img/navigation.png" /></div>
                     
                    </CRow>
                    <hr class="custom-hr" />
                    <CRow>
                        <div style="width:20%;"><img style="width:30px" src="../assets/img/phoneRound.png" /></div>
                        <div style="width:60%;">
                            <CRow>
                                <h5 class="custom-14px poppin-font mt-2 text-left">Phone Number</h5>
                                <br />
                                <br />
                                <div style="width:100%;">
                                    <h5 class="custom-12px poppin-font text-left">**** **** **** 2345</h5>
                                </div>
                            </CRow>
                        </div>
                        <div style="width:20%;"><img style="width:20px" src="../assets/img/navigation.png" /></div>
                        <hr class="custom-hr" />
                    </CRow>
            </CCol>
    
        </CRow>
    </div>
</template>


<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },

        GoToLogin() {
            // Close the popup and backdrop
            this.$router.push("/RegisterHomepage");
        },

        GoToChangePassword() {
            // Close the popup and backdrop
            this.$router.push("/ChangePassword");
        },
        GoToVerify()
        {
            this.$router.push("/InsertEmail");
        }

    }
})
</script>
